import { render } from "./bool-input.component.vue?vue&type=template&id=46043540&scoped=true&ts=true"
import script from "./bool-input.component.vue?vue&type=script&lang=ts"
export * from "./bool-input.component.vue?vue&type=script&lang=ts"

import "./bool-input.component.vue?vue&type=style&index=0&id=46043540&scoped=true&lang=scss"

import exportComponent from "/agent/_work/1/s/Customer/onlinekiosk_vue_js/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46043540"]])

export default __exports__